// extracted by mini-css-extract-plugin
module.exports = {"section":"style_section__8MCdx","edit_section":"style_edit_section__WX3Ra"};